import React from 'react';
import { Stack, Typography } from "@mui/material";
import { DeleteIcone } from "../../../UI/Icons";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomTextField } from '../../../TextField';

const MilestoneHeader = ({ 
  name, 
  setName, 
  error, 
  errorText, 
  handleNameKeyDown, 
  handleDelete, 
  isEditable 
}) => {
  const isMobile = useResponsive("down", "md");
  
  const handleNameChange = (e) => {
    const value = e.target.value;
    if (value.length > 30) {
      setName(value, "Maximum 30 characters allowed", true);
    } else {
      setName(value, "", false);
    }
  };

  return (
    <div className="edit-worklog-title">
      <Stack direction="row" justifyContent="space-between">
        <CustomTextField
          variant="standard"
          sx={{ flexGrow: 1 }}
          onChange={handleNameChange}
          onKeyDown={handleNameKeyDown}
          onBlur={handleNameKeyDown}
          InputProps={{
            disableUnderline: true,
            style: {
              height: 32,
              border: "none",
              fontSize: isMobile ? "16px" : "20px",
              fontWeight: 700,
              color: "#1B3E61",
              pointerEvents: isEditable ? "" : "none",
            },
          }}
          value={name}
        />
        {isEditable && (
          <Stack
            direction="row"
            sx={{
              backgroundColor: "#fff",
              padding: "6px 16px",
              border: "1px solid #919EAB33",
              borderRadius: "4px",
              marginRight: "40px",
              marginTop: "-3px",
              cursor: "pointer",
            }}
            alignItems="center"
            onClick={handleDelete}
          >
            <DeleteIcone height={"24px"} width={"24px"} className={"mr-5"} />
            <Typography fontWeight={500} fontSize={14}>
              Delete
            </Typography>
          </Stack>
        )}
      </Stack>
      {error && <p className="error">{errorText}</p>}
    </div>
  );
};

export default MilestoneHeader; 